export default __webpack_public_path__ + "static/blob5-adde2b86136e4b660bb0e55c1af30e4a.svg";